import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { styled } from '@mui/material/styles';
import KeyboardDoubleArrowDown from '@mui/icons-material/KeyboardDoubleArrowDown'
import KeyboardDoubleArrowUp from '@mui/icons-material/KeyboardDoubleArrowUp'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import { Grid, Typography } from '@mui/material';
import { ISwipeableDrawerCustom } from '../../interfaces';
import { useConfig } from '../../Services/useConfig';




export default function DesktopBottomDrawer(props: any) {

    const config = useConfig()


    const widthBleeding = 150;
    const marginLeft = (-widthBleeding / 2) //(drawerWidth/2)- (width/2)  
    // const maxWidth = 950;
    const drawerBleeding = 56;
    const StyledBox = styled(Box)(({ theme }) => ({
        backgroundColor: theme.palette.customBackground.main
    }));

    const toggleDrawer = (newOpen: boolean) => () => {
        props.setOpen(newOpen);
    };

    console.log(props)

    // Needs to be adjusted so it can be called in ContentBottomDrawer
    return (
        <Box sx={{
            ".MuiDrawer-root > .MuiPaper-root": {
                height: `calc(50% - ${drawerBleeding}px+20px)`,
                overflow: "visible",
                backgroundColor: 'customBackground.main',
                marginLeft: config.general["leftDrawerWidthDesktop"]
            }
        }}>
            <SwipeableDrawer
                // style={{marginLeft: min(`calc(100% - ${props.drawerWidth}px`)}}
                sx={{
                    '& .MuiDrawer-paper': {
                        height: "500px",


                    }
                }}
                anchor="bottom"
                open={props.open}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                swipeAreaWidth={56}
                disableSwipeToOpen={false}
                ModalProps={{
                    keepMounted: true,
                }}
                variant="persistent" //remove to activate swipe behaviour,
            >
                <Box
                    sx={{
                        px: 2,
                        pb: 2,
                        // height: '80%',
                    }}
                >

                    <StyledBox
                        sx={{
                            position: 'absolute',
                            top: -drawerBleeding + 7,
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            visibility: 'visible',
                            width: `${widthBleeding}px`,
                            ml: `${marginLeft}px`,
                            left: "50%",

                            // (drawerWidth/2)- (width/2)  
                            // right: "40%",
                            // left: "45%",

                        }}
                    >
                        <Box
                            sx={{
                                // position: 'absolute',
                                // left: "50%",
                                // right: "50%"
                                // left: 'calc(50% - 15px)',
                            }}>
                            <Grid container justifyContent="center">
                                <IconButton onClick={toggleDrawer(!props.open)}>
                                    {props.open ? <KeyboardDoubleArrowDown /> : <KeyboardDoubleArrowUp />}
                                </IconButton>
                            </Grid>


                        </Box>
                        <Container sx={{ p: 1 }}></Container>
                    </StyledBox>
                    {props.children}
                </Box>
            </SwipeableDrawer>
        </Box>
    )
}

